export function handleAnchorLinkClick(
  event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  targetId: string,
  headerHeight: number,
) {
  event.preventDefault();
  const targetElement = document.getElementById(targetId);
  if (targetElement) {
    const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
}
